import React from 'react';

/**
 * Input Component - Reusable input field with label and error states
 * 
 * @param {string} label - Input label
 * @param {string} error - Error message to display
 * @param {string} type - Input type (text, password, email, etc.)
 * @param {string} placeholder - Placeholder text
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {string} className - Additional CSS classes
 * @param {boolean} required - Mark as required
 * @param {number} maxLength - Maximum length
 */
const Input = ({
    label,
    error,
    type = 'text',
    placeholder,
    value,
    onChange,
    className = '',
    required = false,
    maxLength,
    ...props
}) => {
    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            {label && (
                <label className="text-sm font-medium text-slate-200">
                    {label}
                    {required && <span className="text-red-400 ml-1">*</span>}
                </label>
            )}
            <input
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                maxLength={maxLength}
                required={required}
                className={`
          w-full px-4 py-2.5 rounded-lg
          bg-surface border border-white/10
          text-slate-100 placeholder-slate-500
          focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary
          transition-all duration-200
          ${error ? 'border-red-500 focus:ring-red-500/50' : ''}
        `}
                {...props}
            />
            {error && (
                <span className="text-sm text-red-400 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {error}
                </span>
            )}
        </div>
    );
};

export default Input;
